export default {
  name: 'dataset',
  signature: '[COMMAND]',
  isGroupRoot: true,
  description: 'Manages datasets, like create or delete, within projects',
}
